import React, { forwardRef, useState } from 'react';
import { useInitialHtml, useServerHtml } from './InitialHtmlContext';

// These classes belong to the motion controller. Adopt its current state on
// the first render so hydration never removes/restarts an entrance. Later
// React renders keep the same props, leaving the controller in charge.
const AOS_ATTRIBUTES = ['data-aos', 'data-aos-delay', 'data-aos-duration', 'data-aos-easing'];
const MOTION_CLASSES = ['hm-motion', 'in', 'go', 'aos-init', 'aos-animate'];
export function initialElement(key) {
  return Array.from(document.querySelectorAll('[data-initial-motion]'))
    .find((element) => element.getAttribute('data-initial-motion') === key);
}
const InitialMotion = forwardRef(function InitialMotion({ as: Tag = 'div', motionKey, className, ...props }, ref) {
  const initialHtml = useInitialHtml();
  const serverHtml = useServerHtml();
  const [motion] = useState(() => {
    const element = initialHtml && !serverHtml && initialElement(motionKey);
    return element ? {
      classes: MOTION_CLASSES.filter((name) => element.classList.contains(name)),
      aos: Object.fromEntries(AOS_ATTRIBUTES.filter((name) => name in props)
        .map((name) => [name, element.getAttribute(name) || undefined])),
      open: element.hasAttribute('open'),
    } : null;
  });
  const classes = [className, ...(motion?.classes || [])].filter(Boolean).join(' ');
  return <Tag {...props} ref={ref} className={classes || undefined}
    {...(motion?.aos || {})}
    {...(Tag === 'details' && motion ? { open: motion.open } : {})}
    data-initial-motion={motionKey} />;
});
export default InitialMotion;
